<script>
export default {
  props: {
    size: {
      type: String,
      default: '24',
    },
    color: {
      type: String,
      default: 'primary',
    },
    width: {
      type: Number,
      default: 3,
    },
  },
}
</script>

<template>
  <div class="w-100 d-flex justify-center items-center">
    <v-progress-circular
      indeterminate
      :color="color"
      :size="size"
      :width="width"
    ></v-progress-circular>
  </div>
</template>
